import { AbstractEntity } from "../Common/AbstractEntity"

export interface MasterFSPEntity extends AbstractEntity {
    id: number,
    priority: number,
    status: string | null,
    shippingLine: string | null,
    effectiveDateFrom: Date | null,
    effectiveDateTo: Date | null,
    consortiumCode: string | null,
    serviceCode: string | null,
    forwarderCode: string | null,
    agentCode: string | null,
    cargoCode: string | null,
    fspCountingFrom: string | null,
    fspCountingTo: string | null,
    graceHourTo: number | null,
    graceHourFrom: number | null,
    graceMinuteTo: number | null,
    graceMinuteFrom: number | null,
    shipmentType: string | null,
    fspCountingDirection: string | null,
    fspDays: number | null,
    fspUOM: string | null,
    chargeType: string | null,
    subChargeType: string | null,
    cntrMovement: string | null,
    cntrStatus: string | null,
    customerType: string | null,
    forwarderReference: string | null,
    fspCalculateMethod: string | null,
    vesselCode: string | null,
    voyageCode: string | null,
    applyCalendarAdj: string | null,
    splitFirstDays: number | null,
    splitFirstDaysTo: string | null,
    splitRemainDaysTo: string | null,
    rejectReason: string | null,
    remarks: string | null,
    graceExtend: string | null,
    activeInd: string | null,
    confirmedDate: Date | null,
    fspCountingFromDisVal: string | null,
    fspCountingToDisVal: string | null,

    [key: string]: string | boolean | number | null | undefined | Object
}

export const EMPTY_MASTER_FSP_ENTITY: MasterFSPEntity = {
    id: 0,
    priority: 0,
    status: null,
    shippingLine: null,
    effectiveDateFrom: null,
    effectiveDateTo: null,
    consortiumCode: null,
    serviceCode: null,
    forwarderCode: null,
    agentCode: null,
    cargoCode: null,
    fspCountingFrom: null,
    fspCountingTo: null,
    graceHourTo: null,
    graceHourFrom: null,
    graceMinuteTo: null,
    graceMinuteFrom: null,
    shipmentType: null,
    fspCountingDirection: null,
    fspDays: null,
    fspUOM: null,
    chargeType: null,
    subChargeType: null,
    cntrMovement: null,
    cntrStatus: null,
    customerType: null,
    forwarderReference: null,
    fspCalculateMethod: null,
    vesselCode: null,
    voyageCode: null,
    applyCalendarAdj: null,
    splitFirstDays: null,
    splitFirstDaysTo: null,
    splitRemainDaysTo: null,
    rejectReason: null,
    remarks: null,
    graceExtend: null,
    activeInd: 'Y',
    confirmedDate: null,
    fspCountingFromDisVal: null,
    fspCountingToDisVal: null,
}

